import { Default_Page_Limit, Default_Page_Number } from "../../../../../constants/defaultValues";
import {
  HandlePaginationActionProps,
  HandleSearchProps,
  InProcessDataProps,
  ModifiedDataProps,
  SetDataForPaginationProps,
} from "../interface";

export const paginationFunction = () => {
  const setDataForPagination = ({
    listingData,
    limitPerPage,
    currentPage,
  }: SetDataForPaginationProps): ModifiedDataProps => {
    const startIndex = (currentPage - 1) * limitPerPage;
    const endIndex = startIndex + limitPerPage;
    const paginatedData = listingData?.slice(startIndex, endIndex);

    const modifiedData = {
      data: paginatedData,
      totalPages: Math.ceil(listingData?.length / limitPerPage),
      count: listingData?.length,
      currentPage: currentPage,
    };

    return modifiedData;
  };

  const handleSearch = ({
    value,
    data,
    setCurrentPage,
    setLimitPerPage,
    setStoreAllocationList,
    setAllocationPartialData,
  }: HandleSearchProps) => {
    let modifiedData: ModifiedDataProps;
    setCurrentPage(Default_Page_Number);
    setLimitPerPage(Default_Page_Limit);
    if (!value) {
      modifiedData = setDataForPagination({
        listingData: data,
        limitPerPage: Default_Page_Limit,
        currentPage: Default_Page_Number,
      });
      setAllocationPartialData(data);
      setStoreAllocationList(modifiedData);

      return;
    }

    let filterData: InProcessDataProps[] = data?.filter((item) =>
      item?.order_id_display?.toLowerCase()?.includes(value.toLowerCase())
    );


    modifiedData = setDataForPagination({
      listingData: filterData,
      limitPerPage: Default_Page_Limit,
      currentPage: Default_Page_Number,
    });
    setAllocationPartialData(filterData);
    setStoreAllocationList(modifiedData);
  };

  const handlePaginationAction = ({
    data,
    limit,
    page,
    setStoreAllocationList
  }: HandlePaginationActionProps) => {
    let params: SetDataForPaginationProps = {
      listingData: data,
      limitPerPage: limit,
      currentPage: page
    };
    let modified_data = setDataForPagination(params);
    setStoreAllocationList(modified_data);

  };

  return {
    setDataForPagination,
    handleSearch,
    handlePaginationAction
  };
};
